import "./crash/install_first.js";
import { CrashReporter, crashCapture } from "./crash/crash_reporter.js";
import { CrashIdentity } from "./crash/identity.js";
import { ensureDeviceId } from "./utils/device_id.js";
import { ensureUserId } from "./analytics/analytics_identity.js";
import { SimulationRunner } from "./simulation/simulation_runner.js";
import { TestLevelBridge } from "./debug/test_level_bridge.js";
import { exposeStabilityCheck } from "./debug/stability_check.js";
import { LevelPoolBrowser } from "./debug/level_pool_browser.js";

// Dev helper: jump straight to a screen from the browser console.
( window as any ).showScreen = ( name: string ) =>
{
  void ScreenManager.showScreen( name as Screens );
};
( window as any ).currentScreen = () => ScreenManager.getCurrentScreenInstance();
( window as any ).runSim = ( level: number, runs = 1000 ) =>
  new SimulationRunner().run( level, runs );

( window as any ).runRange = ( from: number, to: number, runs = 300 ) =>
  new SimulationRunner().runRange( from, to, runs );

exposeStabilityCheck();
LevelPoolBrowser.expose();

let analytics_enabled_late = false;

async function enableAnalyticsAfterLateConsent(): Promise<void>
{
  if ( ANALYTICS_OFF || analytics_enabled_late || !S2SEventContextService.getConsentSnapshot().analytics_allowed ) return;
  analytics_enabled_late = true;
  CrashIdentity.setConsentAllowed( true );
  analytics.setEnabled( true );
  console.info( '[Startup] analytics enabled after late consent' );
}

import { Game } from "./game.js";
import { LocalizationManager } from "./localization/localization_manager.js";
import { TelegramAPISettings } from "./telegram_api_settings.js";
import { performLogin } from "./api/perform_login.js";
import { reportSessionStart, reportLevelActive } from "./api/requests/economy.requests.js";
import { syncAppsflyerAttribution } from "./analytics/appsflyer_attribution.js";
import { NetworkError, setOnUnauthorized } from "./api/http_client.js";
import { analytics, AnalyticsEventName, AnalyticsPropertyKey, initAnalytics, trackWebEvent } from "./analytics/index.js";
import { OfferService } from "./offers/offer_service.js";
import { logAfAppOpen, logAfSessionMinuteMilestone } from "./analytics/appsflyer_events.js";
import * as MaxAds from "./ads/applovin_max.js";
import { S2SEventContextService } from "./s2s/s2s_event_context.js";
import { AdsConfigService } from "./ads/ads_config.js";
import { AppConfigService } from "./app_config/app_config_service.js";
import { LevelPackService } from "./level_pack/level_pack_service.js";
import { CannonConfigService } from "./cannon_config/cannon_config_service.js";
import { ConveyorConfigService } from "./conveyor_config/conveyor_config_service.js";
import { ConveyorLevelsService } from "./conveyor_config/conveyor_levels_service.js";
import { EventsConfigService } from "./events_config/events_config_service.js";
import { areBundledLevelsAllowed } from "./level_config.js";
import { maybeShowUpdateDialog } from "./app_config/app_update_check.js";
import { ScreenManager, Screens } from "./screen_manager/screen_manager.js";
import { DebugConsoleManager } from "./debug/debug_console.js";
import { DebugSettings, GlobalSettings } from "./global_settings.js";
import { LogOverlay } from "./debug/log_overlay.js";
import { audioController } from "./audio/audio_controller.js";
import { StatisticsStorage } from "./storage/statistics_storage.js";
import { nextHeartAtMs } from "./api/player_sync.js";
import { SocketHandler } from "./socket_handler/socket_handler.js";
import { ANALYTICS_OFF } from "./analytics/analytics_off.js";
import { NetworkManager } from "./network_manager.js";
import { SessionController } from "./socket_handler/controllers/session_controller.js";
import { AppVersionController } from "./socket_handler/controllers/app_version_controller.js";
import { ServerRoutingService } from "./server_routing/server_routing_service.js";
import { NotificationManager } from "./notifications/notification_manager.js";
import { NotificationConfigService } from "./notifications/notification_config.js";
import { OfferTriggerController } from "./offers/offer_trigger_controller.js";
import { OfflineMode } from "./offline/offline_mode.js";
import { AuthSessionStore } from "./api/auth_session.js";
import { OfflineSyncService } from "./offline/offline_sync_service.js";
import { OfflineEconomy, OFFLINE_ECONOMY_CONFIG_TYPES } from "./offline/offline_economy.js";
import { OfflineJournal } from "./offline/offline_journal.js";
import { ConfigSyncService } from "./config_sync/config_sync_service.js";
import { CumulativeBoosterService } from "./cumulative_boosters/cumulative_booster_service.js";
import { ConfigHashStore } from "./config_sync/config_hash_store.js";
import { fetchBootstrap, primeFromBootstrap } from "./api/requests/bootstrap.requests.js";
import { PrimedResponses } from "./api/primed_responses.js";
import { TransportFlags } from "./api/transport_flags.js";
import { isConfigMissing } from "./utils/network_errors.js";
import * as EconomyGateway from "./offline/economy_gateway.js";
// import { DevToDev } from "./plugins/dev_to_dev_plugin.js";

// import { VConsoleManager } from "./vconsole_manager.js";
// import { GlobalSettings } from "./global_settings.js";

// if ( GlobalSettings.IS_PROD )
// {
//   console.log = () => {};
//   console.warn = () => {};
//   console.info = () => {};
//   console.debug = () => {};
// }

// if ( window.Capacitor )
// {
//   // @ts-ignore  //Ця ліба опціональна і не потрібна для веба, тому щоб компілятор не сварився коли її немає - юзаємо  ts-ignore
//   import( '@capacitor/app' ).then( ( { App } ) =>
//   {
//     if ( window.Capacitor && window.Capacitor.Plugins )
//     {
//       window.Capacitor.Plugins.App = App;
//     }
//   } ).catch( error =>
//   {
//     console.error( 'Failed to import Capacitor App plugin:', error );
//     console.error( 'Не забудь встановити ліби - npm i :');
//   } );
//
//   // @ts-ignore //Ця ліба опціональна і не потрібна для веба, тому щоб компілятор не сварився коли її немає - юзаємо  ts-ignore
//   import( '@capacitor/dialog' ).then( ( { Dialog } ) =>
//   {
//     if ( window.Capacitor && window.Capacitor.Plugins )
//     {
//       window.Capacitor.Plugins.Dialog = Dialog;
//     }
//   } ).catch( error =>
//   {
//     console.error( 'Failed to import Capacitor Dialog plugin:', error );
//     console.error( 'Не забудь встановити ліби - npm i :');
//   } );
//
//   // @ts-ignore
//   import( '@capacitor/haptics' ).then( ( { Haptics } ) =>
//   {
//     if ( window.Capacitor && window.Capacitor.Plugins )
//     {
//       window.Capacitor.Plugins.Haptics = Haptics;
//     }
//   } ).catch( error =>
//   {
//     console.error( 'Failed to import Capacitor Haptics plugin:', error );
//     console.error( 'Не забудь встановити ліби - npm i :');
//   } );
// }

function preventCollapse() // vertical scroll bug fix (Telegram issue)
{
  document.body.style.overflowY = 'hidden'
  document.body.style.height = ( window.innerHeight + Game.getYOverflow() ) + "px"
  window.scrollTo( 0, Game.getYOverflow() );
}

const SESSION_MILESTONE_MINUTES = [ 1, 2, 4, 6, 10, 15 ] as const;
let session_elapsed_ms = 0;
let session_last_tick_ms: number | null = null;
const sent_session_milestones = new Set<number>();
let is_session_timer_paused = document.hidden;
let is_app_backgrounded = document.hidden;
let foregrounded_at_ms = Date.now();
let backgrounded_at_ms: number | null = null;

const SESSION_RESUME_THRESHOLD_MS = 30_000;

const reportSessionToServer = ( settle_abandoned = false ): void =>
{
  if ( !NetworkManager.isOnline() )
    return;

  void OfflineSyncService.sync( 'session_start' )
    .then( () => reportSessionStart( settle_abandoned ) )
    .then( result =>
    {
      if ( OfflineJournal.hasPending() )
        return;
      StatisticsStorage.update( {
        hearts: result.hearts,
        max_hearts: result.max_hearts,
        next_heart_at: nextHeartAtMs( result.next_heart_at, 0 ),
      } );
      void OfferTriggerController.report( 'session_started' );
    } )
    .catch( e => console.warn( '[Economy] session-start failed', e ) );
};

const pauseSessionMilestoneTracking = (): void =>
{
  is_session_timer_paused = true;
  session_last_tick_ms = null;
};

const resumeSessionMilestoneTracking = (): void =>
{
  is_session_timer_paused = false;
  session_last_tick_ms = null;
};

const reportLevelActivity = ( active: boolean ): void =>
{
  if ( ScreenManager.getCurrentScreen() !== Screens.GAME ) return;

  void reportLevelActive( active ).catch( e => console.warn( '[Economy] level-active failed', e ) );
};

const handleAppBackground = (): void =>
{
  if ( is_app_backgrounded ) return;
  is_app_backgrounded = true;
  backgrounded_at_ms = Date.now();
  CrashReporter.checkpoint( 'backgrounded' );
  pauseSessionMilestoneTracking();
  reportLevelActivity( false );
};

const handleAppForeground = (): void =>
{
  if ( !is_app_backgrounded ) return;
  is_app_backgrounded = false;
  foregrounded_at_ms = Date.now();
  CrashReporter.checkpoint( 'foreground' );
  resumeSessionMilestoneTracking();
  void ServerRoutingService.checkIfStale( 'foreground' );
  void logAfAppOpen( 'unknown' );
  reportLevelActivity( true );
  void OfflineSyncService.sync( 'foreground' );
  void ConfigSyncService.refreshStale( 'foreground', { throttle: true } );

  if ( backgrounded_at_ms != null && Date.now() - backgrounded_at_ms >= SESSION_RESUME_THRESHOLD_MS )
    reportSessionToServer();
  backgrounded_at_ms = null;
};

const tickSessionMilestones = ( now_ms: number ): void =>
{
  if ( is_session_timer_paused ) return;
  if ( session_last_tick_ms == null )
  {
    session_last_tick_ms = now_ms;
    return;
  }

  const delta_ms = Math.max( 0, now_ms - session_last_tick_ms );
  session_last_tick_ms = now_ms;
  session_elapsed_ms += delta_ms;

  for ( const minute of SESSION_MILESTONE_MINUTES )
  {
    if ( sent_session_milestones.has( minute ) ) continue;
    if ( session_elapsed_ms < minute * 60_000 ) continue;

    sent_session_milestones.add( minute );
    void logAfSessionMinuteMilestone( minute );
    analytics.track( AnalyticsEventName.SESSION_MIN, {
      [AnalyticsPropertyKey.TIMESTAMP]: new Date().toISOString(),
      [AnalyticsPropertyKey.SESSIONMIN]: minute
    } );
  }
};

const startSessionMilestoneLoop = (): void =>
{
  const step = ( now_ms: number ): void =>
  {
    tickSessionMilestones( now_ms );
    window.requestAnimationFrame( step );
  };

  window.requestAnimationFrame( step );
};

function syncBannerVisibilityWithCurrentScreen(): void
{
  const current_screen = ScreenManager.getCurrentScreen();
  MaxAds.setBannerInitialDelay( AdsConfigService.get().banner.initial_delay_seconds * 1000 );
  MaxAds.setBannerVisible( current_screen !== Screens.GAME );
}

function registerConfigSync(): void
{
  ConfigSyncService.register( [ 'ads' ], () => AdsConfigService.refresh(), () => AdsConfigService.hasCachedConfig() );
  ConfigSyncService.register( [ 'app', 'booster_highlight_config' ], () => AppConfigService.refresh(), type => AppConfigService.hasCachedConfig( type ) );
  ConfigSyncService.register( [ 'cannon' ], () => CannonConfigService.refresh(), () => CannonConfigService.hasCachedConfig() );
  ConfigSyncService.register( [ 'conveyor' ], () => ConveyorConfigService.refresh(), () => ConveyorConfigService.hasCachedConfig() );
  ConfigSyncService.register( [ 'conveyor_levels' ], () => ConveyorLevelsService.refresh(), () => ConveyorLevelsService.hasCachedConfig() );
  ConfigSyncService.register( [ 'events_unlock' ], () => EventsConfigService.refresh(), () => EventsConfigService.hasCachedConfig() );
  ConfigSyncService.register( [ 'notifications' ], () => NotificationConfigService.refresh(), () => NotificationConfigService.hasCachedConfig() );
  ConfigSyncService.register( [ ...OFFLINE_ECONOMY_CONFIG_TYPES ], stale => OfflineEconomy.refreshConfigs( stale ), type => OfflineEconomy.hasCachedConfig( type ) );
  ConfigSyncService.register( [ 'boosters_prices' ], () => CumulativeBoosterService.refreshPricesConfig(), type => CumulativeBoosterService.hasCachedConfig( type ) );
  ConfigSyncService.register( [ 'boosters_properties' ], () => CumulativeBoosterService.refreshPropertiesConfig(), type => CumulativeBoosterService.hasCachedConfig( type ) );
  ConfigSyncService.register( [ 'level_pack' ], () => LevelPackService.refresh(), () => LevelPackService.hasCachedRelease() );
}

const BOOTSTRAP_RETRY_MS = 60_000;

class BootstrapIncompleteError extends Error
{
  constructor( missing: string[] )
  {
    super( `[Startup] first online bootstrap incomplete: ${missing.join( ', ' )}` );
    this.name = 'BootstrapIncompleteError';
  }
}

// One POST replaces the config-hashes, stale content-config and three event
// GETs that used to run in sequence after login. The responses are parked in
// PrimedResponses and consumed by the very same request functions the rest of
// the startup calls, so nothing downstream knows the difference. Any failure
// simply leaves the old per-request path in place.
async function primeStartupFromBootstrap(): Promise<void>
{
  PrimedResponses.clear();
  if ( !NetworkManager.isOnline() ) return;
  try
  {
    const payload = await fetchBootstrap( ConfigSyncService.knownHashes(), ConfigSyncService.registeredTypes() );
    const primed = primeFromBootstrap( payload );
    console.info( `[Bootstrap] primed ${primed} startup response(s), ${Object.keys( payload.configs ?? {} ).length} config(s) stale` );
  }
  catch ( e )
  {
    if ( isConfigMissing( e ) )
      console.info( '[Bootstrap] server has no bootstrap route, using separate requests' );
    else
      console.warn( '[Bootstrap] failed, using separate requests', e );
  }
}

async function performLoginAndRefreshAdsConfig(): Promise<void>
{
  try { await performLoginAndRefreshAdsConfigInner(); }
  finally { PrimedResponses.clear(); }
}

async function performLoginAndRefreshAdsConfigInner(): Promise<void>
{
  const first_bootstrap = !OfflineMode.isBootstrapped();
  const missing: string[] = [];

  const logged_in = await performLogin();
  if ( !logged_in || !AuthSessionStore.isLoggedIn() )
    throw new NetworkError( 'login failed' );
  CrashIdentity.setUser( AuthSessionStore.getPlayerId() );
  CrashReporter.checkpoint( 'logged_in' );
  await SessionController.sendStartSession();
  await primeStartupFromBootstrap();
  const configs = await ConfigSyncService.refreshStale( 'startup' );
  CrashReporter.checkpoint( 'configs_ready' );
  if ( !configs.checked ) missing.push( 'configs' );
  missing.push( ...configs.incomplete.map( type => `config:${type}` ) );
  if ( !TestLevelBridge.isLocalLevelsForced() )
  {
    const restored_from_cache = LevelPackService.restoreCachedForFastStart();
    const refresh = LevelPackService.refresh();
    if ( !restored_from_cache || first_bootstrap )
      await refresh;

    const warmup = refresh
      .then( () => LevelPackService.ensureLevel( StatisticsStorage.load().level ) )
      .then( () => LevelPackService.prefetchOfflineWindow( StatisticsStorage.load().level ) );
    if ( first_bootstrap )
    {
      await warmup.catch( e => console.warn( "[LevelPack] startup level warmup failed", e ) );
      if ( !LevelPackService.isLevelCached( StatisticsStorage.load().level ) ) missing.push( 'levels' );
      else CrashReporter.checkpoint( 'levels_ready' );
    }
    else
      void warmup
        .then( () => CrashReporter.checkpoint( 'levels_ready' ) )
        .catch( e => console.warn( "[LevelPack] startup level warmup failed", e ) );

    if ( !LevelPackService.isActive() && !areBundledLevelsAllowed() )
      throw new Error( "[LevelPack] no server release available — startup is not complete" );
  }

  if ( !NetworkManager.isOnline() ) missing.push( 'network' );
  if ( missing.length === 0 )
    OfflineMode.markBootstrapComplete();
  else if ( first_bootstrap )
    throw new BootstrapIncompleteError( missing );
  else
    console.warn( `[Startup] bootstrap incomplete, running on cached data: ${missing.join( ', ' )}` );

  syncBannerVisibilityWithCurrentScreen();
  void AppVersionController.requestAndWait().then( () => maybeShowUpdateDialog() );
}

let resolveStartupReady: () => void = () => {};
const startup_ready = new Promise<void>( resolve => { resolveStartupReady = resolve; } );

async function loadInitialNetworkDataWithRetry(): Promise<void>
{
  let delay_ms = 2_000;
  let routing_rechecked = false;

  for ( let attempt = 1; ; attempt++ )
  {
    if ( !NetworkManager.isOnline() && OfflineMode.canStartOffline() )
    {
      OfflineMode.enterOfflineStartup();
      resolveStartupReady();
    }
    await NetworkManager.waitForOnline();
    try
    {
      if ( attempt === 1 )
        void ServerRoutingService.check( 'startup' );
      await performLoginAndRefreshAdsConfig();
      if ( attempt > 1 )
      {
        console.info( `[LoadRetry] initial network data loaded on attempt ${attempt}` );
        NetworkManager.clearLoadingError();
      }
      resolveStartupReady();
      return;
    }
    catch ( error )
    {
      if ( error instanceof NetworkError || !NetworkManager.isOnline() )
      {
        NetworkManager.handleNetworkError( error );
        if ( OfflineMode.canStartOffline() )
        {
          OfflineMode.enterOfflineStartup();
          resolveStartupReady();
        }
      }
      else if ( error instanceof BootstrapIncompleteError )
      {
        console.warn( `[LoadRetry] ${error.message} — starting on what loaded, retrying in ${BOOTSTRAP_RETRY_MS / 1000}s` );
        resolveStartupReady();
      }
      else if ( OfflineMode.startedOffline() )
        console.warn( '[LoadRetry] initial network data failed while playing offline-started session', error );
      else
        NetworkManager.handleLoadingDataError( error );

      // The current server may be gone for good: ask the home server once
      // whether we were redirected before retrying against a dead address.
      if ( !routing_rechecked && NetworkManager.isOnline() )
      {
        routing_rechecked = true;
        await ServerRoutingService.check( 'login_failed' );
      }

      await NetworkManager.waitForOnline();
      const retry_ms = error instanceof BootstrapIncompleteError ? BOOTSTRAP_RETRY_MS : delay_ms;
      await new Promise( resolve => window.setTimeout( resolve, retry_ms ) );
      delay_ms = Math.min( delay_ms * 2, 15_000 );
    }
  }
}

window.addEventListener( "load", async () =>
{
  LogOverlay.startCapture();
  preventCollapse();

  try
  {
    await NetworkManager.init();
    // The analytics WebSocket is Royal Smash's: JustSmash never connects (see analytics_off.ts).
    if ( !ANALYTICS_OFF ) new SocketHandler();

    const analytics_ready = ( async (): Promise<void> =>
    {
      let analytics_enabled = !ANALYTICS_OFF;
      if ( !ANALYTICS_OFF && MaxAds.isNative() )
      {
        const privacy_ready = await MaxAds.ensureLazyInit();
        analytics_enabled = privacy_ready
          && S2SEventContextService.getConsentSnapshot().analytics_allowed;
      }
      CrashReporter.checkpoint( 'consent_resolved' );
      CrashIdentity.setConsentAllowed( analytics_enabled );
      await initAnalytics( { enabled: analytics_enabled } );
      if ( !analytics_enabled )
        MaxAds.onLateInit( () => { void enableAnalyticsAfterLateConsent(); } );
      await NotificationManager.consumeLaunchEvents();
      if ( !ANALYTICS_OFF ) void logAfAppOpen( globalThis.__launchedFromPush ? 'push_notification' : 'icon' );
      startSessionMilestoneLoop();
    } )().catch( error => console.warn( '[Startup] analytics init failed', error ) );

    // // @ts-ignore
    // import( '@capacitor/haptics' ).then( ( { Haptics } ) =>
    // {
    //   if ( window.Capacitor && window.Capacitor.Plugins )
    //   {
    //     window.Capacitor.Plugins.Haptics = Haptics;
    //   }
    // } ).catch( error =>
    // {
    //   console.error( 'Failed to import Capacitor Haptics plugin:', error );
    // } );

    // VConsoleManager.initEruda();

    const appStartTs = performance.now();
    // void DevToDev.appStart();

    let firstScreenReported = false;
    // const origShow = ( ScreenManager as any ).show?.bind( ScreenManager );
    // if ( origShow )
    // {
    //   ( ScreenManager as any ).show = function ( ...args: any[] )
    //   {
    //     if ( !firstScreenReported )
    //     {
    //       firstScreenReported = true;
    //       const dt = performance.now() - appStartTs;
    //       // void DevToDev.firstScreenShown( dt );
    //     }
    //     return origShow( ...args );
    //   };
    // }
    await TelegramAPISettings.init();
    await Game.initializeSafeAreas();
    LocalizationManager.setRemoteReadyPromise(
      LocalizationManager.loadRemote()
        .catch( error => console.warn( '[Startup] remote localization failed', error ) )
    );

    const detected_lang =
      LocalizationManager.getSavedLanguage()
      ?? LocalizationManager.resolveSupportedLanguage( TelegramAPISettings.getUserLanguage() )
      ?? LocalizationManager.detectLanguageFromNavigator();
    if ( detected_lang )
      LocalizationManager.setLanguage( detected_lang );

    // Headless batches (stability / simulation) must not depend on the actual
    // window: hidden or zero-sized viewports (0×0 breaks ballistics with NaNs)
    // and differently-sized monitors would change camera/cannon geometry and
    // make results non-reproducible. Fixed portrait size for every batch tab.
    const headless_batch = TestLevelBridge.isBatchActive();
    const telegram_metrics = TelegramAPISettings.getScreenMetrics();
    const viewport_w = Math.round( visualViewport?.width ?? telegram_metrics.width );
    const viewport_h = Math.round( telegram_metrics.height );

    const game = new Game(
      headless_batch || viewport_w < 50 ? 390 : viewport_w,
      headless_batch || viewport_h < 50 ? 844 : viewport_h
    );

    TelegramAPISettings.subscribeToLayoutChanges( () => game.updateTelegramLayout() );
    setInterval( preventCollapse, 400 );

    try
    {
      const cap: any = ( window as any ).Capacitor;
      const appPlugin = cap?.Plugins?.App;
      if ( appPlugin?.addListener )
      {
        void appPlugin.addListener( 'appStateChange', ( state: { isActive: boolean } ) =>
        {
          if ( state?.isActive )
          {
            handleAppForeground();
            void audioController.resumeFromForeground();
            void NotificationManager.onForeground();
          }
          else
          {
            handleAppBackground();
            void audioController.suspendForBackground();
          }
        } );
      }

      document.addEventListener( 'visibilitychange', () =>
      {
        if ( document.hidden )
        {
          handleAppBackground();
          void audioController.suspendForBackground();
        }
        else
        {
          handleAppForeground();
          void audioController.resumeFromForeground();
          void NotificationManager.onForeground();
        }
      } );

      window.addEventListener( 'nativeAudioFocusChange', ( ev: any ) =>
      {
        const state = ev?.detail?.state as string;
        if ( !state ) return;
        if ( state === 'duck' )
        {
          audioController.duck();
        }
        else if ( state === 'gain' )
        {
          audioController.unduck();
          void audioController.resumeFromForeground();
        }
        else
        {
          void audioController.suspendForBackground();
        }
      } );
    }
    catch ( e )
    {
      console.warn( 'Lifecycle audio setup failed', e );
      crashCapture( e, { phase: 'audio_lifecycle' } );
    }

    game.initBackButton();
    let menu_shown_reported = false;
    ScreenManager.addOnChangeListener( next =>
    {
      MaxAds.setBannerVisible( next !== Screens.GAME );
      CrashReporter.breadcrumb( 'screen', String( next ?? 'none' ) );
      if ( next === Screens.MENU && !menu_shown_reported )
      {
        menu_shown_reported = true;
        CrashReporter.checkpoint( 'menu_shown' );
      }
      if ( next === Screens.GAME )
        CrashReporter.checkpoint( 'level_started' );
    } );
    CrashReporter.setScreenProvider( () => ScreenManager.getCurrentScreen() );
    CrashReporter.setSnapshotProvider( () => ( {
      screen: ScreenManager.getCurrentScreen(),
      level: StatisticsStorage.load().level,
      release_uid: LevelPackService.getReleaseUid(),
      uptime_ms: Math.round( performance.now() ),
      foreground_ms: is_app_backgrounded ? null : Date.now() - foregrounded_at_ms,
      online: NetworkManager.isOnline(),
      offline_playable: OfflineMode.isPlayable(),
      backgrounded: is_app_backgrounded,
      telegram_platform: window.Telegram?.WebApp?.platform ?? null,
    } ) );
    void ensureDeviceId().then( id => CrashIdentity.setDevice( id ) ).catch( () => {} );
    try { CrashIdentity.setAnalyticsId( ensureUserId() ); } catch {}
    if ( !TestLevelBridge.isLocalLevelsForced() )
      LevelPackService.restoreCachedForFastStart();
    NetworkManager.setOfflinePlayableCheck( () => OfflineMode.isPlayable() );
    registerConfigSync();
    ( window as any ).offlineDebug = {
      configHashes: () => ConfigHashStore.getAll(),
      bootstrapped: () => OfflineMode.isBootstrapped(),
      resetBootstrap: () => OfflineMode.resetBootstrap(),
      configSync: ( reason = 'debug' ) => ConfigSyncService.refreshStale( reason ),
      configSyncAll: ( reason = 'debug' ) => ConfigSyncService.refreshAll( reason ),
      journal: () => OfflineJournal.list(),
      clearJournal: () => OfflineJournal.clear(),
      sync: ( reason = 'debug' ) => OfflineSyncService.sync( reason ),
      isOnline: () => NetworkManager.isOnline(),
      simulateOffline: () => NetworkManager.handleNetworkError( new Error( 'debug offline' ) ),
      cachedAhead: () => LevelPackService.countCachedAhead( StatisticsStorage.load().level ),
      prefetch: () => LevelPackService.prefetchOfflineWindow( StatisticsStorage.load().level ),
      play: ( level: number ) => ScreenManager.showScreen( Screens.GAME, { level } ),
      gateway: EconomyGateway,
      probe: () => NetworkManager.retryByUser(),
      stats: () => StatisticsStorage.load(),
    };
    ( window as any ).offersDebug = { service: OfferService, analytics };
    ( window as any ).transportDebug = {
      describe: () => TransportFlags.describe(),
      use: ( format: 'json' | 'msgpack' | null ) => TransportFlags.setOverride( format ),
      bootstrap: () => fetchBootstrap( ConfigSyncService.knownHashes(), ConfigSyncService.registeredTypes() ),
      primed: () => PrimedResponses.size(),
    };
    NetworkManager.addOnlineListener( () => { void OfflineSyncService.sync( 'online' ); } );
    OfflineJournal.subscribe( pending =>
    {
      if ( pending > 0 && NetworkManager.isOnline() && !OfflineSyncService.isReplaying() )
        void OfflineSyncService.sync( 'journal' );
    } );
    OfflineMode.startHeartRegenTicker();
    setOnUnauthorized( async () => { await performLogin(); } );
    const initial_network_data = loadInitialNetworkDataWithRetry();
    game.setMenuStartupReadyPromise( startup_ready );
    LevelPackService.setStartupReadyPromise(
      TestLevelBridge.isLocalLevelsForced() ? Promise.resolve() : startup_ready
    );
    void game.init().catch( e =>
      crashCapture( e, { phase: 'game_init' } ) );

    const game_loaded_at = new Date().toISOString();
    void analytics_ready.then( () =>
      trackWebEvent( 'game_loaded', { timestamp: game_loaded_at } ) );

    DebugConsoleManager.attachSecretCodeListener();
    if ( DebugSettings.SHOW_DEBUG_CONSOLE_ENTRY_BUTTON )
      DebugConsoleManager.attachEntryButton();
    void initial_network_data.then( () =>
    {
      ServerRoutingService.markStartupComplete();
      reportSessionToServer( true );
      void analytics_ready.then( () => syncAppsflyerAttribution() );
    } );

    setTimeout( () =>
    {
      void NotificationManager.init().then( () => NotificationManager.onForeground() );
    }, 2000 );
  }
  catch ( e: any )
  {
    console.error( 'App init failed', e );
    crashCapture( e, { phase: 'game_load' }, false );
    throw e;
  }

} );
